if (!customElements.get('cm-desktop-bento')) {
  customElements.define('cm-desktop-bento', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.viewport = window.matchMedia('(min-width: 980px)');
      this.panel = this.querySelector('.cm-bento__panel');
      this.tabs = [...this.querySelectorAll('[data-cm-group]')];
      this.buttons = this.tabs.filter(tab => tab.tagName === 'BUTTON');
      if (!this.panel || !this.panel.showPopover) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.updatePosition = () => {
        this.panel.style.setProperty('--cm-bento-top', `${Math.round(this.getBoundingClientRect().bottom)}px`);
      };
      this.isOpen = () => this.panel.matches(':popover-open');
      this.activate = (tab) => {
        const group = tab.dataset.cmGroup;
        this.buttons.forEach(button => button.setAttribute('aria-expanded', String(button === tab)));
        this.panel.querySelectorAll('[data-cm-card]').forEach(card => card.toggleAttribute('data-cm-active', card.dataset.cmCard === group));
        this.lastTrigger = tab;
      };
      this.open = tab => {
        if (!this.viewport.matches) return;
        clearTimeout(this.closeTimer);
        this.updatePosition();
        if (!this.isOpen()) this.panel.showPopover();
        this.activate(tab);
      };
      this.close = () => {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        if (this.isOpen()) this.panel.hidePopover();
      };
      this.scheduleClose = () => {
        clearTimeout(this.openTimer);
        this.closeTimer = setTimeout(() => {
          if (!this.contains(document.activeElement) && !this.matches(':hover') && !this.panel.matches(':hover')) this.close();
        }, 220);
      };
      this.tabs.forEach(tab => {
        tab.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.closeTimer);
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => this.open(tab), 130);
        }, options);
        tab.addEventListener('keydown', event => {
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          this.open(tab);
          this.panel.querySelector(`[data-cm-card="${tab.dataset.cmGroup}"] a, a[data-cm-card="${tab.dataset.cmGroup}"]`)?.focus();
        }, options);
        if (tab.tagName === 'BUTTON') tab.addEventListener('click', event => {
          event.preventDefault();
          if (this.isOpen() && this.lastTrigger === tab) this.close(); else this.open(tab);
        }, options);
      });
      this.panel.addEventListener('beforetoggle', event => {
        if (event.newState === 'open') this.updatePosition();
      }, options);
      this.panel.addEventListener('toggle', () => {
        if (!this.isOpen()) this.buttons.forEach(button => button.setAttribute('aria-expanded', 'false'));
      }, options);
      this.panel.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
      this.panel.addEventListener('pointerleave', this.scheduleClose, options);
      this.addEventListener('pointerleave', this.scheduleClose, options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (!this.contains(document.activeElement)) this.close(); });
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.isOpen()) {
          event.preventDefault();
          this.close();
          this.lastTrigger?.focus();
        }
      }, options);
      this.querySelector('.cm-bento__close').addEventListener('click', event => {
        event.preventDefault();
        this.close();
        this.lastTrigger?.focus();
      }, options);
      this.onViewportChange = () => { if (!this.viewport.matches) this.close(); };
      this.viewport.addEventListener('change', this.onViewportChange, options);
      window.addEventListener('resize', this.updatePosition, options);
      window.addEventListener('scroll', () => { if (this.isOpen()) this.updatePosition(); }, { ...options, passive: true });
      this.onSectionUnload = event => { if (event.detail.sectionId === this.dataset.sectionId) this.close(); };
      document.addEventListener('shopify:section:unload', this.onSectionUnload, options);
    }
    disconnectedCallback() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.abort?.abort();
      this.initialized = false;
    }
  });
}
